export default __webpack_public_path__ + "static/media/videos.ea4e9216.svg";